<div *ngIf="newHomePedirDelivery" class="new-design">
	<div id="menu-list" style="position: relative">
		<div *ngIf="featuredVisible.length">
			<div class="category-header">
				<h1 id="featuredItems" class="category-name">{{featuredItemsCategoryName}}</h1>
			</div>
			<div class="featured-carousel" appDragScroll>
				<ng-container *ngFor="let item of featuredVisible; trackBy: trackById">
					<span style="position: relative">
						<card
							[item]="item"
							[isFeatured]="true"
							[newHomePedirDelivery]="newHomePedirDelivery"
						></card>
					</span>
				</ng-container>
			</div>
		</div>
	</div>

	<div *ngIf="combosVisible.length">
		<div class="category-header">
			<h1 id="combos" class="category-name">{{comboCategoryName}}</h1>
		</div>
		<card
			*ngFor="let item of combosVisible; trackBy: trackById"
			style="width: 100%"
			[item]="item"
			[newHomePedirDelivery]="newHomePedirDelivery"
		></card>
	</div>

	<div *ngIf="pizzaSizesVisible.length">
		<div class="category-header">
			<h1 id="pizzas" class="category-name">{{pizzaCategoryName}}</h1>
		</div>
		<card *ngFor="let item of pizzaSizesVisible; trackBy: trackById" style="width: 100%" [item]="item" [newHomePedirDelivery]="newHomePedirDelivery">
		</card>
	</div>

	<!-- `generalView` contém só as categorias já INICIADAS pelo render progressivo (a
	     última pode estar parcial). O `| slice:0:visibleGeneralLimit` que ficava aqui
	     saiu: era redundante e o SlicePipe é impuro (rodava a cada change detection). -->
	<div
        *ngFor="let view of generalView; trackBy: trackByCategory"
		style="position: relative"
		id="{{view.category.name}}-{{view.category.id}}"
	>
		<!-- `mpCategoryCards` é a fronteira OnPush da categoria: o cabeçalho abaixo é
		     PROJETADO (continua deste template e com o estilo deste componente) e os
		     cards vêm em fatias OnPush de 48 depois dele. O `<span style="position:relative">`
		     que envolvia cada card saiu no Caso 17 — o overlay do item indisponível vive no
		     próprio card (`.product-card-new-design { position: relative }`). -->
		<div
			*ngIf="view.hasProducts"
			class="scroll-category"
			mpCategoryCards
			[view]="view"
			[revision]="view.revision"
			[newHomePedirDelivery]="newHomePedirDelivery"
		>
			<div class="category-header">
				<h1 [id]="view.category.id" class="category-name">{{view.category.name}}</h1>
				<p *ngIf="view.hasDescription && !isInstagramUA" class="text-wrap category-description" [innerHTML]="view.descriptionHtml"></p>
				<p *ngIf="view.hasDescription && isInstagramUA" class="text-wrap category-description">{{view.descriptionText}}</p>
			</div>
		</div>
	</div>
</div>

<!-- Versão antiga — RECRIADO sem Ionic (mp): ion-list/ion-item-group → div; ion-label → span.
     ion-list/item-group são só containers (display:block); os títulos/descrição mantêm as classes.
     O `<span style="position:relative">` que envolvia CADA card também saiu do layout legado
     (Caso 17-B) — 1 nó por produto, ~1.950 numa distribuidora. Era bloco de contenção do
     overlay do item indisponível (`.product-card--disabled::after`), mas esse pseudo pende do
     próprio `.mp-card`, que já é `position: relative`. Diferente do carrossel de destaques do
     layout NOVO, onde `.featured-carousel span { flex: 0 0 170px }` dimensiona o item e o span
     FICA: o legado não tem carrossel. -->
<div id="menu-list" class="menu-list-legacy" style="position: relative" *ngIf="!newHomePedirDelivery">
	<div *ngIf="featuredVisible.length">
		<h1 id="featuredItems" class="category-name">{{featuredItemsCategoryName}}</h1>
		<card
			*ngFor="let item of featuredVisible; trackBy: trackById"
			style="width: 100%"
			[item]="item"
			[newHomePedirDelivery]="newHomePedirDelivery"
		></card>
	</div>

	<div *ngIf="combosVisible.length">
		<h1 id="combos" class="category-name">{{comboCategoryName}}</h1>
		<card
			*ngFor="let item of combosVisible; trackBy: trackById"
			style="width: 100%"
			[item]="item"
			[newHomePedirDelivery]="newHomePedirDelivery"
		></card>
	</div>

	<div *ngIf="pizzaSizesVisible.length">
		<h1 id="pizzas" class="category-name">{{pizzaCategoryName}}</h1>
		<card *ngFor="let item of pizzaSizesVisible; trackBy: trackById" style="width: 100%" [item]="item" [newHomePedirDelivery]="newHomePedirDelivery">
		</card>
	</div>

	<!-- Mesmo desenho do layout novo: `mpCategoryCards` (OnPush) projeta o cabeçalho e
	     põe os cards em fatias OnPush de 48. -->
	<div
        *ngFor="let view of generalView; trackBy: trackByCategory"
		style="position: relative"
		id="{{view.category.name}}-{{view.category.id}}"
	>
		<div
			*ngIf="view.hasProducts"
			class="scroll-category"
			mpCategoryCards
			[view]="view"
			[revision]="view.revision"
			[newHomePedirDelivery]="newHomePedirDelivery"
		>
			<h1 [id]="view.category.id" class="category-name">{{view.category.name}}</h1>
			<span class="mp-label text-wrap category-description" *ngIf="view.hasDescription && !isInstagramUA"><span [innerHTML]="view.descriptionHtml"></span></span>
			<span class="mp-label text-wrap category-description" *ngIf="view.hasDescription && isInstagramUA">{{view.descriptionText}}</span>
		</div>
	</div>
</div>

<!-- ngSkipHydration: o popup move o próprio overlay para o <body> (appBodyPortal), e a
     hidratação não acompanha nó movido. Ele nasce fechado, então renderizar do zero no
     cliente não muda nada na tela. -->
<app-featured-coupon-popup ngSkipHydration></app-featured-coupon-popup>
